import RankBadgeSkeleton from './Skeleton';
import { RankBadgeProps } from './props';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import Color from 'color';
import { Image } from '@starsoft/common/components';
import { RankGroupId } from '@/enums/rankGroupId';

export default function RankBadge({
  isLoading,
  rankGroup,
  isSecondaryStyles,
  showIcon = false,
}: RankBadgeProps) {
  const { t, lang: language } = useTranslation('vip-club');
  const { t: tCommon } = useTranslation('common');
  const firstRank: string =
    rankGroup?.firstRank?.name?.[language]?.split(' ')?.[1];
  const lastRank: string =
    rankGroup?.lastRank?.name?.[language]?.split(' ')?.[1];
  const name: string =
    rankGroup?.id > RankGroupId.DiamondIII
      ? rankGroup?.name?.[language]
      : tCommon(`${rankGroup?.id}_rank_label`);

  if (isLoading) {
    return <RankBadgeSkeleton isSecondaryStyles={isSecondaryStyles} />;
  }

  return (
    <div
      className={`${styles.container} ${isSecondaryStyles ? styles['container--secondary'] : ''}`}
    >
      {!showIcon && (
        <div
          className={styles.container__card}
          style={{
            backgroundColor: rankGroup?.color
              ? Color(rankGroup?.color).alpha(0.4).toString()
              : undefined,
            color: rankGroup?.color,
          }}
          color={rankGroup?.color}
        >
          {!isSecondaryStyles && name}
        </div>
      )}
      {showIcon && (
        <Image
          width={20}
          height={20}
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/ranks/medal/${rankGroup?.image}`}
          alt={rankGroup?.name?.[language]}
        />
      )}

      <div className={styles.container__row}>
        {isSecondaryStyles && (
          <span className={styles.container__label}>{name}</span>
        )}

        <span className={styles.container__label}>
          VIP {firstRank}
          {lastRank !== firstRank && `-${lastRank}`}
          {rankGroup?.id > 2 && !isSecondaryStyles && (
            <> {t('perk_disclaimer')}</>
          )}
        </span>
      </div>
    </div>
  );
}
